@if (show) {
  <div style="display: grid">
    <mat-form-field (click)="$event.stopPropagation()"
      (keydown.space)="$event.stopPropagation()"
      (keydown.control.a)="$event.stopPropagation()">
      <mat-label>{{ 'COMMON.search_by_name' | translate }}</mat-label>
      <input #input (ngModelChange)="onFilterChange($event)" [(ngModel)]="name" autocomplete="off" matInput>
    </mat-form-field>
  </div>
}
